import { LoginSso } from '@/components/feature/LoginPage'

const Login = () => {
  return <LoginSso />
}

export default Login
